module.exports = __webpack_public_path__ + "img/footer_icon_youtube.7052488c.svg";